// extracted by mini-css-extract-plugin
export var saBoxes4Blocks = "saGrid-module--saBoxes4Blocks--Rqmbz";
export var saItem = "saGrid-module--saItem--JqlkH";
export var saItemBlock = "saGrid-module--saItemBlock--2YeC4";
export var saItemTitle = "saGrid-module--saItemTitle--2ghpZ";
export var saItemText = "saGrid-module--saItemText--1-2E3";
export var saItemImage = "saGrid-module--saItemImage--1vyX4";